import { NgModule } from '@angular/core';

import { FacsComponent } from './facs.component';
import { SharedModule } from '../shared/shared.module';
import { EditFacModalModule } from '../shared/components/edit-fac-modal/edit-fac-modal.module';
import { FacsService } from './service/facs.service';
import { FacsFiltersComponent } from './facs-filters/facs-filters.component';
import { NzDatePickerModule } from 'ng-zorro-antd';
import { FacsTourComponent } from './facs-tour/facs-tour.component';
import { TourCardComponent } from './facs-tour/tour-card/tour-card.component';
import { BulkErrorModalComponent } from './bulk-error-modal/bulk-error-modal.component';

@NgModule({
  declarations: [
    FacsComponent,
    FacsFiltersComponent,
    FacsTourComponent,
    TourCardComponent,
    BulkErrorModalComponent
  ],
  imports: [
    SharedModule,
    EditFacModalModule,
    NzDatePickerModule,
  ],
  exports: [
    FacsComponent,
    FacsFiltersComponent
  ],
  providers: [
    FacsService
  ]
})
export class FacsModule { }
